<script>
import EventTile from './event-tile.vue'
import EventDetails from './event-details.vue'

export default {
  name: 'EventsList',
  components: { EventTile, EventDetails },
  props: {
    events: {
      type: Array,
      required: true,
    },
    currentUserId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      singleEvent: false,
    }
  },
  methods: {
    openEventModal(oneEvent) {
      this.singleEvent = oneEvent
      // remove url with params if you open an event from company page sidebar
      window.localStorage.removeItem('events_with_filters')
      // show  company/:companyId/events/:eventId so the user can copy the URL
      window.history.pushState(
        {},
        null,
        window.location.pathname + '/events/' + oneEvent.id
      )
    },
    closeModal() {
      this.singleEvent = null
      // just go back on close
      window.history.back()
    },
  },
}
</script>

<template>
  <div>
    <EventTile
      v-for="oneEvent in events"
      :key="oneEvent.id"
      :one-event="oneEvent"
      @open-modal="openEventModal(oneEvent)"
    ></EventTile>
    <EventDetails
      v-if="singleEvent"
      :one-event="singleEvent"
      :current-user-id="currentUserId"
      @close="closeModal"
    ></EventDetails>
    <RouterView :key="$route.fullPath" />
  </div>
</template>
